import React from 'react';
import { Button } from './Button';
import { urls } from '../urls';

export const Credits = props => {
    return (<div className="nc-credits">
        <div>
            <div className="nc-title">You have <span>{props.smsCredit}</span> credits</div>
            <div className="nc-statement">each 160 character sms uses 1 credit</div>
        </div>
        {!props.hideButton && <div><Button classNames={["nc-buynow"]} text="buy more" to={urls.router.store.index.url} /></div>}
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/Credits.js